module.exports = __webpack_public_path__ + "assets/img/zhengzhou.4082c849.png";